import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { brands, BrandType } from 'noddi-types';
import { NoddiBasicCard, NoddiTextArea } from 'noddi-ui-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';

type CommentBoxProps = {
  handleChange: (s: string) => void;
  comment?: string | null;
  placeholder?: string;
  title?: string;
};

const getBrandPlaceHolderComments = (brand: BrandType) => {
  if (
    brand === brands.noddi ||
    brand === brands.bestdrive ||
    brand === brands.dekkstra ||
    brand === brands.tronderdekk
  ) {
    return t`Optional note if any extra information is needed, like where to find tires, keys etc.`;
  }

  return t`Optional note if any extra information is needed like parking info etc.`;
};

export const CommentBox = ({ handleChange, comment, placeholder, title }: CommentBoxProps) => {
  const { currentBrand } = useCurrentBrand();
  const commentPlaceHolder = getBrandPlaceHolderComments(currentBrand);
  return (
    <NoddiBasicCard className='flex flex-col gap-3'>
      <p className='font-semibold'>{title ?? <Trans>Anything more we should know?</Trans>}</p>

      <NoddiTextArea
        onChange={(e) => handleChange(e.target.value)}
        value={comment ?? ''}
        placeholder={placeholder ?? commentPlaceHolder}
      />
    </NoddiBasicCard>
  );
};
